// ── verifiedAccounts.js ─────────────────────────────────────────────────────
// قائمة الحسابات الموثقة + قائمة مالكي الموقع
// الشارتان تظهران على مستوى الموقع بالكامل (Navbar، EditProfile، ViewProfile، ... إلخ)

// ── معرفات الحسابات الموثقة ────────────────────────────────────────────────
export const VERIFIED_UIDS = new Set([
  "rkushaOMOzYqPQN7gCbNyKtwnnG3",
  "FbdlRwDY7hVyyI8XUKzB5F1LZ3A3",
]);

// ── معرفات مالكي الموقع ────────────────────────────────────────────────────
// هؤلاء يحصلون على علامة التاج الذهبية بدلاً من علامة التوثيق الزرقاء
export const OWNER_UIDS = new Set([
  "rkushaOMOzYqPQN7gCbNyKtwnnG3",
  "FbdlRwDY7hVyyI8XUKzB5F1LZ3A3",
]);

/**
 * هل هذا الحساب موثق؟
 * @param {string} uid
 * @returns {boolean}
 */
export const isVerifiedUser = (uid) => {
  if (!uid) return false;
  return VERIFIED_UIDS.has(uid);
};

/**
 * هل هذا الحساب خاص بأحد مالكي الموقع؟
 * مالكو الموقع يحصلون على علامة التاج الذهبية بدلاً من علامة التوثيق.
 * @param {string} uid
 * @returns {boolean}
 */
export const isOwnerUser = (uid) => {
  if (!uid) return false;
  return OWNER_UIDS.has(uid);
};
